<template>
    <div :style="{'font-family': design.font_name + ' !important'}">
      <div v-for="(line, idx) in schedule" :key="idx">
        <v-row>
          <v-col cols="12" md="3" sm="4" lg="2" xs="12" class="mb-0 pb-0 pr-0 text-center text-sm-right text-md-right">
            <div class="pr-1 d-inline-block mt-1">
              <template v-if="show_weekday">
                <span :style="{color: design.headercolor}">
                  {{dateLabel(line.date)}}
                  <br />
                  {{weekday(line.date)}}
                </span>
              </template>
              <template v-else>
                <div class="text-right" :style="{color: design.headercolor}">
                  {{ headerText }}
                  <div v-if="headerText2" style="font-size: 0.75rem">{{ headerText2 }}</div>
                </div>
              </template>
            </div>
          </v-col>
          <v-col class="mb-0 pb-0"  md="9" sm="8" lg="10" xs="12">
            <div
              style="display: inline-block"
              class="slotBase"
              v-for="slot in line.schedule"
              :key="slot.time"
            >
              <button
                :style="slotStyle(slot)"
                :class="!slot.free ? 'slotBase-disabled': ''"
                :disabled="!slot.free"
                @click="clickSlot(slot, line.date, $event)"
              >{{slot.time}}</button>
              <br />
              <div
                class="text-center"
                :style="{fontSize: design.font_size + 'px', color: design.headercolor}"
              >
                <template v-if="slot.free">
                  <span v-if="slot.discount_price" :style="{color: 'red'}"><b>{{slot.discount_price}}!</b></span>
                  <span v-else>{{slot.price}}</span>
                </template>
                <div v-else style="opacity: 0">*</div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
</template>
<script>
import Vue from "vue";
import fonts from "./fonts";


var moment = require("moment");

export default {
  props: {
    design: Object,
    schedule: Array,
    questId: {
      default: 0,
      type: Number,
    },
    colorsMap: Object,
    headerText: {
      default: '',
      type: String
    },
    headerText2: {
      default: '',
      type: String
    },
    show_weekday: Boolean,
  },
  data: () => {
    return {};
  },
  mounted() {
    // Нужно скачать все нужные скрипты
    this.cssFontBlock = document.createElement("link");
    this.cssFontBlock.setAttribute("href", fonts.FONTS[0][1]);
    this.cssFontBlock.setAttribute("rel", "stylesheet");
    document.head.appendChild(this.cssFontBlock);
    var font = fonts.FONTS.find(el => {
        return el[0] == this.design.font_name;
      });
      if (font) {
        this.cssFontBlock.remove();
        this.cssFontBlock = document.createElement("link");
        this.cssFontBlock.setAttribute("href", font[1]);
        this.cssFontBlock.setAttribute("rel", "stylesheet");

        document.head.appendChild(this.cssFontBlock);
      }
  },
  computed: {
    slotBaseStyle() {
      if (this.design.padding_top == undefined) {
        Vue.set(this.design, "padding_top", 3);
      }

      return {
        padding:
          this.design.padding_top +
          "px " +
          this.design.padding_side +
          "px " +
          this.design.padding_top +
          "px " +
          this.design.padding_side +
          "px !important",
        margin: "0px",
        marginLeft: this.design.margin + "px !important",
        marginRight: this.design.margin + "px !important",
        color: this.design.textcolor,
        boxShadow:
          "0 0 " + this.design.shadow_size + "px rgba(0, 0, 0, 0.5) !important",
        heigth: 36 + 2 * this.design.border + "px !important",
        fontFamily: this.design.font_name + " !important",
      };
    }
  },
  methods: {
    slotStyle(slot) {
      var colorNum = this.colorsMap[slot.price];
      const borderColor = this.design.bordercolors[colorNum];
      const backgroundColor = this.design.colors[colorNum];
      var customStyle = {
        borderColor: this.design.bordercolors[colorNum],
        backgroundColor: backgroundColor,
        border: this.design.border + "px solid " + borderColor,
        borderRadius: this.design.radius + 'px !important',
      };
      var style = Object.assign({}, customStyle, this.slotBaseStyle);
      return style;
    },
    dateLabel(date_str) {
      return moment(date_str)
        .locale(window.locale)
        .format("DD.MM");
    },
    weekday(date_str) {
      var s = moment(date_str)
        .locale(window.locale)
        .format("dddd");
      s = s[0].toUpperCase() + s.slice(1);
      return s;
    },
    clickSlot(slot, date, event) {
      slot.questId = this.questId;
      this.$emit("slotClick", slot, date, event);
    }
  },
  watch: {
    "design.font_name": function(value) {
      var font = fonts.FONTS.find(el => {
        return el[0] == value;
      });
      if (font) {
        this.cssFontBlock.remove();
        this.cssFontBlock = document.createElement("link");
        this.cssFontBlock.setAttribute("href", font[1]);
        this.cssFontBlock.setAttribute("rel", "stylesheet");

        document.head.appendChild(this.cssFontBlock);
      }
    }
  }
};
</script>

<style scoped>
.slotBase {
  text-align: center !important;
}
.slotBase:hover {
  transform: scale(1.05);
}
.slotBase-disabled {
  opacity: 0.3;
}
</style>